module.exports = __webpack_public_path__ + "img/travel-insurance-icon.8b8d3339.svg";